// If we import the name directly from the package.json, we lose the actual type of the module. it will be considered as string, and not "@malt/nuxt-i18n-module"
export const name = '@malt/nuxt-i18n-module';
